"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimStatus = exports.ClaimDskuType = exports.ClaimableType = exports.ClaimSource = exports.ClaimReason = exports.OverallClaimStatus = void 0;
exports.OverallClaimStatus = {
    OPEN: "OPEN",
    CLOSED_FULLY_APPROVED: "CLOSED_FULLY_APPROVED",
    CLOSED_FULLY_REJECTED: "CLOSED_FULLY_REJECTED",
    CLOSED_FULLY_RETRACTED: "CLOSED_FULLY_RETRACTED",
};
exports.ClaimReason = {
    OUTBOUND_DAMAGED_PACKAGED: "OUTBOUND_DAMAGED_PACKAGED",
    OUTBOUND_DELIVERED_BUT_LOST: "OUTBOUND_DELIVERED_BUT_LOST",
    OUTBOUND_LATE_DELIVERY: "OUTBOUND_LATE_DELIVERY",
    OUTBOUND_LOST_PACKAGE: "OUTBOUND_LOST_PACKAGE",
    OUTBOUND_MISSING: "OUTBOUND_MISSING",
    OUTBOUND_MISSHIP_MERCHANT_SKU: "OUTBOUND_MISSHIP_MERCHANT_SKU",
    OUTBOUND_MISSHIP_ROGUE_SKU: "OUTBOUND_MISSHIP_ROGUE_SKU",
};
exports.ClaimSource = {
    SELLER_PORTAL: "SELLER_PORTAL",
    NETWORK_API: "NETWORK_API",
};
exports.ClaimableType = {
    ORDER: "ORDER",
    ORDER_ITEM: "ORDER_ITEM",
};
var ClaimDskuType;
(function (ClaimDskuType) {
    ClaimDskuType["INCORRECT"] = "INCORRECT";
    ClaimDskuType["MISSING"] = "MISSING";
})(ClaimDskuType = exports.ClaimDskuType || (exports.ClaimDskuType = {}));
var ClaimStatus;
(function (ClaimStatus) {
    ClaimStatus["PENDING"] = "PENDING";
    ClaimStatus["APPROVED"] = "APPROVED";
    ClaimStatus["REJECTED"] = "REJECTED";
    ClaimStatus["RETRACTED"] = "RETRACTED";
    ClaimStatus["APPEALED"] = "APPEALED";
})(ClaimStatus = exports.ClaimStatus || (exports.ClaimStatus = {}));
//# sourceMappingURL=Claim.js.map